
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsSkuGrid extends Serenity.EntityGrid<CsSkuRow, any> {
        protected getColumnsKey() { return CsSkuColumns.columnsKey; }
        protected getDialogType() { return CsSkuDialog; }
        protected getIdProperty() { return CsSkuRow.idProperty; }
        protected getInsertPermission() { return CsSkuRow.insertPermission; }
        protected getLocalTextPrefix() { return CsSkuRow.localTextPrefix; }
        protected getService() { return CsSkuService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: CsSkuService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }

    }
}